import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getHitsPerPage } from 'selectors/algolia2/url'
const mapStateToProps = createStructuredSelector({
  hitsPerPage: getHitsPerPage,
})

const mapDispatchToProps = () => ({})

export type ConnectorProps = {
  hitsPerPage: number
}
export default connect(mapStateToProps, mapDispatchToProps)
